import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const getAddress = (id) => {
  return axios.get(API + "parties/manage-address/" + id + "/", { headers: authHeader() })
}

const addContract = (contract_number, description, customer_id, start_date, contract_term, address_id, contract_type, end_date, paymentstartdate, loanamount, iir, interestcalculationmethod, repaymentprocedure, timecountingmethod,
  paymentmethod, deposit_amount,
  feesontime,
  tax_rate_rent,
  tax_rate_fee,
  extrafiledcontract,
  frequency,
  paymentrule,
  achPayments,
  achAccount,
  appOriginator,
  source,
  salesRep,
  subcompany,
  line_of_business,
  interest_only_payments,
  contractTerms,
  interest_rate_type,
  base_rate,
  margin,
  principal_basis,
  credit_line,
  draw_start_date,
  draw_end_date,
  interest_pay_frequency,
  principal_pay_frequency,
  credit_type,
  loan_principal

) => {
  return axios.post(API + "contracts/create-contract/", {
    contract_number,
    description,
    customer_id,
    start_date,
    contract_term,
    address_id,
    contract_type,
    end_date,
    paymentstartdate,
    loanamount,
    iir,
    interestcalculationmethod,
    repaymentprocedure,
    timecountingmethod,
    // interestpostingfrequency,
    paymentmethod,
    deposit_amount,
    feesontime,
    tax_rate_rent,
    tax_rate_fee,
    extrafiledcontract,
    frequency,
    paymentrule,
    enable_ach: achPayments ? 'Y' : 'N',
    ach_account_id: achAccount || null,
    appOriginator,
    source,
    salesRep,
    subcompany,
    line_of_business,
    interest_only_payments,
    termsCondition: contractTerms,
    interest_rate_type: interest_rate_type,
    base_rate: interest_rate_type === "Floating" ? base_rate : 0,
    margin: interest_rate_type === "Floating" ? margin : 0,
    principal_basis,
    credit_line,
    draw_start_date,
    draw_end_date,
    interest_pay_frequency,
    principal_pay_frequency,
    credit_type,
    loan_principal,

  }, { headers: authHeader(), });
};
const AddContractLineOfCreditService = {
  addContract,
  getAddress,
};
export default AddContractLineOfCreditService;